export * from './baProfilePicture.pipe';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/pipes/baProfilePicture/index.ts